const Info = ({ ...props }) => {
    return (
        <svg
            width="10px"
            height="10px"
            viewBox="0 0 10 10"
            version="1.1"
            {...props}
        >
            <g
                id="Checkout"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g
                    id="Checkout---Sign-In---Existing-Account---Desktop"
                    transform="translate(-633.000000, -329.000000)"
                >
                    <g
                        id="Street-Copy-2"
                        transform="translate(188.000000, 315.000000)"
                    >
                        <g id="Field">
                            <g
                                id="Info"
                                transform="translate(445.000000, 14.000000)"
                            >
                                <path
                                    d="M5,0 C2.24300858,0 0,2.24300858 0,5 C0,7.75699142 2.24300858,10 5,10 C7.75699142,10 10,7.75699142 10,5 C10,2.24300858 7.75702694,0 5,0 Z M5,9.33333333 C2.61060147,9.33333333 0.666666667,7.38943384 0.666666667,5 C0.666666667,2.61056616 2.61060147,0.666666667 5,0.666666667 C7.38939853,0.666666667 9.33333333,2.61060147 9.33333333,5 C9.33333333,7.38939853 7.38939853,9.33333333 5,9.33333333 Z"
                                    id="Shape"
                                    fill="currentColor"
                                    fillRule="nonzero"
                                />
                                <circle
                                    id="Oval"
                                    fill="currentColor"
                                    fillRule="nonzero"
                                    cx="5"
                                    cy="3"
                                    r="1"
                                />
                                <rect
                                    id="Rectangle-4"
                                    stroke="currentColor"
                                    x="4.5"
                                    y="5.16666667"
                                    width="1"
                                    height="2.33333333"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}

export default Info
